import { Link } from "react-router-dom";
import { TodayButtonContents } from "./TodayButtonContents";
import { cn } from "@tellescope/ui";

export type TodayButtonProps =
  | {
      onClick: () => void;
    }
  | {
      route: string;
      replace?: boolean;
    };

export const TodayButton = (props: TodayButtonProps) => {
  const className = cn(
    "flex flex-col items-center justify-center rounded-lg size-14 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
  );

  if ("route" in props) {
    const { route, replace = true } = props;
    return (
      <Link to={route} replace={replace} className={className}>
        <TodayButtonContents />
      </Link>
    );
  }

  return (
    <button onClick={props.onClick} className={className}>
      <TodayButtonContents />
    </button>
  );
};
